import { render } from "./columnShow.vue?vue&type=template&id=1d052f00&scoped=true"
import script from "./columnShow.vue?vue&type=script&lang=js"
export * from "./columnShow.vue?vue&type=script&lang=js"

import "./columnShow.vue?vue&type=style&index=0&id=1d052f00&scoped=true&lang=scss"
import "./columnShow.vue?vue&type=style&index=1&id=1d052f00&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d052f00"]])

export default __exports__